import { Button, InputNumberProps, Modal, ModalProps, Slider } from "antd";
import { useEffect, useState } from "react";

import { ZoomInOutlined } from "@ant-design/icons";
import classNames from "classnames";
import { getListTimeWorkStaff } from "api/tableSession";
import { queryKeys } from "constants/constans";
import styles from "./styles.module.scss";
import useIsMobile from "hooks/useIsMobile";
import { useQuery } from "react-query";

interface IProps extends ModalProps {
  isVisible?: boolean;
  handleCancel: () => void;
}
const ModalViewStaff = (props: IProps) => {
  const { isVisible, handleCancel } = props;
  const [maxCol, setMaxCol] = useState<number>(-1);
  const [zoomLevel, setZoomLevel] = useState(1);
  const { isMobile } = useIsMobile();

  const { data: listTimeWorkStaff } = useQuery(
    [queryKeys.listTimeWorkStaff, isVisible],
    getListTimeWorkStaff
  ) as any;

  useEffect(() => {
    if (isVisible) {
      setZoomLevel(1);
    }
  }, [isVisible]);

  useEffect(() => {
    if (!listTimeWorkStaff) return;
    let max = maxCol;
    Object.keys(listTimeWorkStaff?.data).map((key: string) => {
      if (
        Array.isArray(listTimeWorkStaff?.data?.[key]) &&
        listTimeWorkStaff?.data?.[key]?.length > max
      ) {
        max = listTimeWorkStaff?.data?.[key]?.length;
      }
    });
    setMaxCol(15);
  }, [listTimeWorkStaff]);

  const onChange: InputNumberProps["onChange"] = (newValue) => {
    const screenHeight = window.innerHeight;
    const staffListHeight = screenHeight - (isMobile ? 300 : 250);
    const staffInViewPort = Math.floor(staffListHeight / 33);
    const ratio = staffInViewPort / Object.keys(listTimeWorkStaff?.data).length;
    setZoomLevel((1 - ratio) * (Number(newValue) / 100) + ratio);
  };

  const getMaxLength = () => {
    let maxLength = 0;
    if (!!listTimeWorkStaff?.data) {
      Object.keys(listTimeWorkStaff?.data).map((key: string) => {
        if (
          Array.isArray(listTimeWorkStaff?.data?.[key]) &&
          listTimeWorkStaff?.data?.[key]?.length > maxLength
        ) {
          maxLength = listTimeWorkStaff?.data?.[key]?.length;
        }
      });
    }
    return maxLength; // Trả về 0 nếu không phải mảng
  };

  const calculateWidth = () => {
    const maxLength = Math.max(getMaxLength(), 8);
    const width = (window.innerWidth - (isMobile ? 20 : 203)) / maxLength;
    return Math.max(width, 100);
  };

  return (
    <Modal
      open={isVisible}
      footer={null}
      closable={false}
      className={styles.modalSettingDefault}
      destroyOnClose
      centered
    >
      <div
        className={classNames(styles.modalSettingContainer, {
          [styles.inMobile]: isMobile,
        })}
      >
        <div className={styles.header}>スタッフ予定時間一覧</div>
        <div className={styles.contentContainer}>
          <div
            className={classNames(styles.staffList, {})}
            style={{
              transform: `scale(${zoomLevel || 1})`,
              transformOrigin: "top left",
              width: `${100 / zoomLevel}%`,
              maxHeight: isMobile
                ? `calc((100vh - 300px) / ${zoomLevel})`
                : `calc((100vh - 250px) / ${zoomLevel})`,
            }}
          >
            {!!listTimeWorkStaff?.data &&
              Object.keys(listTimeWorkStaff?.data).map((key: string) => {
                return (
                  <div className={styles.row} key={key}>
                    <div className={styles.staffName}>
                      {listTimeWorkStaff?.data?.[key]?.[0]?.staffName}
                    </div>
                    {Array.isArray(listTimeWorkStaff?.data?.[key]) &&
                      listTimeWorkStaff?.data?.[key]
                        ?.concat(
                          // Tạo các bản ghi trống bổ sung nếu thiếu cột
                          Array.from(
                            {
                              length: Math.max(
                                0,
                                Math.max(getMaxLength(), 8) -
                                  listTimeWorkStaff.data[key].length
                              ),
                            },
                            () => ({})
                          )
                        )
                        .slice(0, maxCol)
                        .map((item: any, index: number) => (
                          <div
                            className={styles.time}
                            key={item?.id || index}
                            style={{ width: `${calculateWidth()}px` }}
                          >
                            {!!item?.infoTable && (
                              <>
                                {item?.infoTable?.code || ""}
                                {item?.infoTable?.no || ""}
                                {item?.index === 3
                                  ? "①"
                                  : item?.index === 2
                                  ? "②"
                                  : item?.index === 1
                                  ? "③"
                                  : "④"}
                                :{item?.startTime || ""}~
                              </>
                            )}
                          </div>
                        ))}
                  </div>
                );
              })}
          </div>
          <div className={styles.btnContainer}>
            <Button
              className={classNames(styles.btn, "btn-default")}
              onClick={() => {
                handleCancel();
              }}
            >
              キャンセル
            </Button>
          </div>
          <div className={styles.zoomContainer}>
            <ZoomInOutlined className={styles.iconZoom} />
            <Slider
              min={0}
              max={100}
              step={10}
              defaultValue={100}
              onChange={onChange}
              marks={{
                0: "0%",
                100: "100%",
              }}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};
export default ModalViewStaff;
